import { api_base_url } from "api/config";
import EscPosEncoder from "esc-pos-encoder";
const encoder = new EscPosEncoder();

export const padSpaces = (val, length, align, truncate = true) => {
  let text = String(val);
  if (text.length < length) {
    switch (align) {
      case "center":
        return text
          .padStart(text.length + Math.floor((length - text.length) / 2), " ")
          .padEnd(length, " ");
      case "right":
        return text.padStart(length, " ");
      default:
        return text.padEnd(length, " ");
    }
  } else {
    return truncate ? `${text.substring(0, length - 2)}..` : text;
  }
};

export const dottedLine = (totalWidth, bold = false) => {
  return encoder.initialize().bold(bold).line("-".repeat(totalWidth)).encode();
};

export const row = ([item1, item2], columnWidths) => {
  return encoder
    .initialize()
    .bold(false)
    .line(
      `${padSpaces(item1, columnWidths[0], "left")}${padSpaces(item2, columnWidths[1], "right")}`
    )
    .encode();
};

export const wrapText = (text, maxWidth) => {
  const words = text.split(" ");
  const lines = [];
  let currentLine = "";

  words.forEach((word) => {
    if ((currentLine + word).length > maxWidth) {
      lines.push(currentLine.trim());
      currentLine = word + " ";
    } else {
      currentLine += word + " ";
    }
  });

  if (currentLine.trim()) {
    lines.push(currentLine.trim());
  }

  return lines;
};

export const divideLines = (text, maxWidth) => {
  for (let i = maxWidth; i < text.length; i += maxWidth) {
    let spaceAdded = false;
    for (let j = i; j > i - 30; j--) {
      if (text[j] === " ") {
        i = j;
        text = [text.slice(0, j + 1), "\n", text.slice(j + 1)].join("");
        spaceAdded = true;
        break;
      }
    }
    if (!spaceAdded) {
      text = [text.slice(0, i + 1), "\n", text.slice(i + 1)].join("");
    }
  }
  return text;
};

export const attachImage = async (url, align) => {
  return new Promise((resolve, reject) => {
    try {
      let img = new Image();
      img.crossOrigin = "anonymous";
      img.src = `${api_base_url}/proxy?url=${url}`;

      let command;
      img.onload = async function () {
        let width = img.width;
        let height = img.height;
        const maxWidth = 400;
        const maxHeight = 250;

        const scale = Math.min(maxWidth / width, maxHeight / height);
        width = Math.round(width * scale);
        height = Math.round(height * scale);

        width = Math.floor(width / 8) * 8;
        height = Math.floor(height / 8) * 8;

        command = encoder
          .initialize()
          .align(align || "center")
          .image(img, width, height, "atkinson")
          .encode();
        resolve(command);
      };
    } catch (error) {
      reject(error);
    }
  });
};

export const softwareBy = () => {
  return encoder
    .initialize()
    .align("center")
    .line(`Software By`)
    .line(`DS Solutions | 0702129472`)
    .encode();
};
